<div class="google-pay-wrapper" [class.google-pay-wrapper-hidden]="!googlePayReady">
  <div #googlePayContainer class="google-pay-button-container"></div>
  <div *ngIf="!termsWereAccepted" class="google-pay-terms-overlay" (click)="overlayClickHandler($event)"></div>
</div>
